<template>
    <!-- 倒数第一个脚注信息 -->
    <div class="footerCopy">
        <el-row class="footer-bottom">
            <el-col :span="24" class="bottomW">©2019畅通圆公司版权所有   青ICP备19001322号
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "footerCopy",
    data() {
        return {};
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footerCopy {
    font-size: 12px;
    text-align: center;
    letter-spacing: 1.2px;
    color: #999999;
    /* margin-top: 50px; */
}
.bottomW{
    /* position: fixed;
    bottom: 0px; */
    border-top: 1px solid #e4e4e4;
    padding: 9px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footerCopy.vue